import {
    initialBlogsFeedPageState,
    initialBlogsFeedState,
    initialBlogsFeedVirtualPageState,
    initialPostsState,
    queryKey,
    BlogsFeedPageState,
    BlogsFeedState,
    BlogsFeedVirtualPageState,
} from 'mk2/apps/blogs/containers/BlogsFeed/BlogsFeed.reducers';
import { AppState } from 'mk2/reducers';
import { BlogPostType } from 'mk2/schemas';

export const getBlogsFeedState = (state: AppState): BlogsFeedState => {
    return state.containers.blogs.blogsFeed || initialBlogsFeedState;
};

export const getBlogsFeedSearchState = (state: AppState, category: string, postType: BlogPostType, query: string) => {
    const blogsFeedState = getBlogsFeedState(state);

    const key = queryKey(category, postType, query);

    if (!blogsFeedState.searches[key]) {
        return initialPostsState;
    }

    return blogsFeedState.searches[key];
};

export const getBlogsFeedPageState = (state: AppState, category: string, postType: BlogPostType, query: string, page: number): BlogsFeedPageState => (
    getBlogsFeedSearchState(state, category, postType, query).pages[page] || initialBlogsFeedPageState
);
export const getBlogsFeedVirtualPageState = (state: AppState, category: string, postType: BlogPostType, query: string, pageName: string): BlogsFeedVirtualPageState => (
    getBlogsFeedSearchState(state, category, postType, query).virtualPages[pageName] || initialBlogsFeedVirtualPageState
);
